import { render, staticRenderFns } from "./ListProductSkeleton.vue?vue&type=template&id=8fc67666&"
import script from "./ListProductSkeleton.vue?vue&type=script&lang=js&"
export * from "./ListProductSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports